import localforage from "../../utils/localforage";

export default function processHoursPerDay(state, arrayDates = []) { 
  const timePerDay = {};
  localforage.getItem("saldo-horas-dia").then((saldos) => {
    if (saldos) {
      arrayDates = saldos;
      saldos.map((value) => {
        let day = value.data;
        if (!timePerDay[day]) {
          timePerDay[day] = {
            horaNormal: value.horasNormais,
            horaPl: value.horasPl,
            horaPt: value.horasPt,
            total: value.horasTotalDia,
          };
        } else {
          timePerDay[day].horaNormal += value.horasNormais;
          timePerDay[day].horaPl += value.horasPl;
          timePerDay[day].horaPt += value.horasPt;
          timePerDay[day].total = value.horasTotalDia;
        }
        return value;
      });
    }
  });
  return timePerDay;
}
